<template>
  <div class="copy" @click="copyToClipboard(value)">
    <slot />
    <BaseSvgIcon
      name="copy"
      class="copy_icon"
      :style="{ minWidth: `${size}px`, minHeight: `${size}px` }"
    />
  </div>
</template>

<script>
import { copyToClipboard } from "@emcd/common/helpers";
import { BaseSvgIcon } from "@/shared/ui";
import "@/assets/icons/SVG/copy.svg";

export default {
  name: "Copy",
  components: { BaseSvgIcon },
  methods: { copyToClipboard },
  props: {
    size: {
      type: Number,
      default: 16,
    },
    value: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.copy {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  &_icon {
    transition: color 0.3s;
    cursor: pointer;
    color: #c18afd;
  }

  &:hover {
    .copy_icon {
      color: #fff;
    }
  }
}
</style>
